import React from 'react';

interface SentimentIndicatorProps {
  sentiment: number; // 0 to 100, where 0 is fully bearish and 100 is fully bullish
}

const SentimentIndicator: React.FC<SentimentIndicatorProps> = ({ sentiment }) => {
  const bearishColor = '#ef5350'; // Red
  const bullishColor = '#26a69a'; // Green

  const gradientStyle = {
    background: `linear-gradient(to right, ${bearishColor} 0%, ${bearishColor} ${100 - sentiment}%, ${bullishColor} ${100 - sentiment}%, ${bullishColor} 100%)`,
  };

  return (
    <div className="sentiment-indicator">
      <h3>Trader Sentiment</h3>
      <div className="sentiment-bar" style={gradientStyle}>
        <div className="sentiment-progress" style={{ width: `${sentiment}%` }}></div>
      </div>
      <div className="sentiment-labels">
        <span>Bearish</span>
        <span>Bullish</span>
      </div>
    </div>
  );
};

export default SentimentIndicator;